<span id="mitsNumberBoxWrapper">
  <span class="mitsNumberBoxLabel" *ngIf="label && label.trim().length > 0">
    {{label}}
  </span>
  <span class="mitsNumberBoxButton disable-text-select" [ngClass]="{'disabled': disabled}"
    (click)="clickSubtract()">-</span>
  <input type="number" [value]="value" (keyup)="changedValue($event)" [min]="minValue" [max]="maxValue"
    [disabled]="disabled">
  <span class="mitsNumberBoxButton disable-text-select" [ngClass]="{'disabled': disabled}" (click)="clickAdd()">+</span>
</span>